var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalP(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 27,
    fill: "#72CD99"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 15.3333C23.9434 15.3333 21.4584 17.8183 21.4584 20.875C21.4584 23.8733 23.8034 26.3 26.86 26.405C26.9534 26.3933 27.0467 26.3933 27.1167 26.405C27.14 26.405 27.1517 26.405 27.175 26.405C27.1867 26.405 27.1867 26.405 27.1984 26.405C30.185 26.3 32.53 23.8733 32.5417 20.875C32.5417 17.8183 30.0567 15.3333 27 15.3333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9266 29.5083C29.6716 27.3383 24.3633 27.3383 21.085 29.5083C19.6033 30.5 18.7866 31.8417 18.7866 33.2767C18.7866 34.7117 19.6033 36.0417 21.0733 37.0217C22.7066 38.1183 24.8533 38.6667 27 38.6667C29.1466 38.6667 31.2933 38.1183 32.9266 37.0217C34.3966 36.03 35.2133 34.7 35.2133 33.2533C35.2016 31.8183 34.3966 30.4883 32.9266 29.5083ZM29.3333 34.1517H27.875V35.61C27.875 36.0883 27.4783 36.485 27 36.485C26.5216 36.485 26.125 36.0883 26.125 35.61V34.1517H24.6666C24.1883 34.1517 23.7916 33.755 23.7916 33.2767C23.7916 32.7983 24.1883 32.4017 24.6666 32.4017H26.125V30.9433C26.125 30.465 26.5216 30.0683 27 30.0683C27.4783 30.0683 27.875 30.465 27.875 30.9433V32.4017H29.3333C29.8116 32.4017 30.2083 32.7983 30.2083 33.2767C30.2083 33.755 29.8116 34.1517 29.3333 34.1517Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalP);
export default __webpack_public_path__ + "static/media/totalP.77c95118.svg";
export { ForwardRef as ReactComponent };